import React, { useState, useEffect } from 'react';

const AdminDashboard = () => {
  const [audits, setAudits] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('audits');

  const apiUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [auditsRes, contactsRes] = await Promise.all([
          fetch(`${apiUrl}/api/audit-submissions`),
          fetch(`${apiUrl}/api/contact-submissions`),
        ]);
        if (!auditsRes.ok || !contactsRes.ok) throw new Error('Failed to fetch data');
        setAudits(await auditsRes.json());
        setContacts(await contactsRes.json());
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [apiUrl]);

  if (loading) return <div style={{ padding: 40 }}>Loading...</div>;
  if (error) return <div style={{ padding: 40, color: 'red' }}>Error: {error}</div>;

  const tableStyle = { width: '100%', borderCollapse: 'collapse', fontSize: 14 };
  const thStyle = { border: '1px solid #ccc', padding: '8px 12px', background: '#f5f5f5', textAlign: 'left', whiteSpace: 'nowrap' };
  const tdStyle = { border: '1px solid #ccc', padding: '8px 12px', verticalAlign: 'top' };
  const tabStyle = (active) => ({
    padding: '10px 24px', cursor: 'pointer', fontWeight: active ? 'bold' : 'normal',
    background: active ? '#333' : '#eee', color: active ? '#fff' : '#333',
    border: 'none', fontSize: 15, borderRadius: '4px 4px 0 0',
  });

  return (
    <div style={{ padding: '40px 20px', maxWidth: 1400, margin: '0 auto', fontFamily: 'sans-serif' }}>
      <h1 style={{ marginBottom: 8 }}>Admin Dashboard</h1>
      <p style={{ color: '#666', marginBottom: 24 }}>
        {audits.length} audit submissions &middot; {contacts.length} contact submissions
      </p>

      <div style={{ marginBottom: 0 }}>
        <button style={tabStyle(activeTab === 'audits')} onClick={() => setActiveTab('audits')}>
          Audit Submissions ({audits.length})
        </button>
        <button style={tabStyle(activeTab === 'contacts')} onClick={() => setActiveTab('contacts')}>
          Contact Submissions ({contacts.length})
        </button>
      </div>

      {activeTab === 'audits' && (
        <div style={{ overflowX: 'auto' }}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Company</th>
                <th style={thStyle}>Phone</th>
                <th style={thStyle}>Score</th>
                <th style={thStyle}>Time Savings</th>
                <th style={thStyle}>Cost Reduction</th>
                <th style={thStyle}>Priority Areas</th>
              </tr>
            </thead>
            <tbody>
              {audits.map((a, i) => (
                <tr key={a.id} style={{ background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={tdStyle}>{i + 1}</td>
                  <td style={{ ...tdStyle, whiteSpace: 'nowrap' }}>
                    {new Date(a.submitted_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                  </td>
                  <td style={tdStyle}>{a.user_info?.name}</td>
                  <td style={tdStyle}>{a.user_info?.email}</td>
                  <td style={tdStyle}>{a.user_info?.company}</td>
                  <td style={tdStyle}>{a.user_info?.phone}</td>
                  <td style={tdStyle}>{a.results?.automationScore}</td>
                  <td style={tdStyle}>{a.results?.timeSavingsPotential}</td>
                  <td style={tdStyle}>{a.results?.costReductionPotential}</td>
                  <td style={tdStyle}>
                    {(a.results?.priorityAreas || []).join(', ')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'contacts' && (
        <div style={{ overflowX: 'auto' }}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Company</th>
                <th style={thStyle}>Phone</th>
                <th style={thStyle}>Subject</th>
                <th style={thStyle}>Message</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((c, i) => (
                <tr key={c.id} style={{ background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={tdStyle}>{i + 1}</td>
                  <td style={{ ...tdStyle, whiteSpace: 'nowrap' }}>
                    {new Date(c.submitted_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                  </td>
                  <td style={tdStyle}>{c.name}</td>
                  <td style={tdStyle}>{c.email}</td>
                  <td style={tdStyle}>{c.company}</td>
                  <td style={tdStyle}>{c.phone}</td>
                  <td style={tdStyle}>{c.subject}</td>
                  <td style={{ ...tdStyle, maxWidth: 300 }}>{c.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
